module.exports = __webpack_public_path__ + "media/images/lp_v6_img23-fdddeaf74473e2a002ff6bb0b409422a.webp";